import BaseModel from "./base/baseModel";

export default class PacoteEntregaModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    altura: number = null;
    largura: number = null;
    comprimento: number = null;
    peso: number = null;
}
